module.exports = __webpack_public_path__ + "static/media/tarjeta-02.cbd0684c.png";